import { GTM_KEY } from '~/types/gtm'
import Country from '~/const/country'

const GTMKeyMapRegions: Partial<Record<GTM_KEY, string[]>> = {
  [GTM_KEY.YH]: [Country.Code.Japan],
  [GTM_KEY.SMB_HUB]: [
    Country.Code.United_States,
    Country.Code.Russia,
    Country.Code.Japan,
    Country.Code.Australia,
    Country.Code.Thailand,
    Country.Code.Vietnam,
    'UAE',
    Country.Code.Turkey,
  ],
  [GTM_KEY.RTBHOUSE]: [
    Country.Code.Vietnam,
    Country.Code.Indonesia,
    Country.Code.Thailand,
    Country.Code.Malaysia,
    Country.Code.Singapore,
    Country.Code.Philippines,
    'KH',
    Country.Code.Australia,
    'NZ',
    Country.Code.South_Korea,
  ],
  [GTM_KEY.TWITTER]: [Country.Code.Japan]
}

/**
 * 规定pixel只允许对应国家的用户使用 与cookiebanner中的cookie consent是&的关系
 * 用户不在对应的country list下 则不允许使用
 * 默认允许使用
 */
export const isUseGTMByRegion = (gtmKey: GTM_KEY, region: string) => {
  const value = GTMKeyMapRegions[gtmKey]
  if (Array.isArray(value)) {
    return value.includes(region)
  }
  return true
}
